import { IApplicationState } from '../../types/redux';
import { IOffer } from '../../types/offer';

export const selectOffer =
  (id: number) =>
  ({ offers }: IApplicationState): IOffer => {
    return offers[id];
  };
